// src/config.js

const BACKEND_URL = 'https://ecomapi.revampbrands.com/api/v1';
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://192.168.1.4:8002/api/v1';
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ecomapi.revampbrands.com/api/v1';

// Public origin used to build callback URLs sent to payment providers
// (Paymob `return_url` / `cancel_url`). Falls back to the runtime origin
// during dev — but production/staging MUST set REACT_APP_PUBLIC_URL so
// the provider doesn't try to redirect the customer back to localhost.
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || (typeof window !== 'undefined' ? window.location.origin : '');

export default BACKEND_URL;
